import { __extends } from "tslib";
import React from 'react';
import IframePopup from '../IframePopup';
var GivePopup = /** @class */ (function (_super) {
    __extends(GivePopup, _super);
    function GivePopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popupRef = React.createRef();
        _this.onMessage = function (_a) {
            var origin = _a.origin, data = _a.data;
            var _b = _this.props, requestClose = _b.requestClose, onBadgeSent = _b.onBadgeSent;
            try {
                var _c = JSON.parse(data), type = _c.type, command = _c.command, width = _c.width, height = _c.height;
                if (!type || type !== 'GiveModal') {
                    return;
                }
                switch (command) {
                    case 'close':
                        requestClose();
                        break;
                    case 'resize':
                    case 'error':
                        var iframe = _this.popupRef.current;
                        iframe && iframe.requestResize({ width: width, height: height });
                        break;
                    case 'badge_receipt':
                        onBadgeSent && onBadgeSent();
                        break;
                    default:
                }
            }
            catch (_d) {
                return;
            }
        };
        return _this;
    }
    GivePopup.prototype.render = function () {
        var _a = this.props, iframeSrc = _a.iframeSrc, title = _a.title, _b = _a.width, width = _b === void 0 ? 450 : _b, _c = _a.height, height = _c === void 0 ? 432 : _c;
        return (React.createElement(IframePopup, { ref: this.popupRef, title: title || '', initialWidth: width, initialHeight: height, src: iframeSrc, onMessage: this.onMessage }));
    };
    return GivePopup;
}(React.Component));
export default GivePopup;
//# sourceMappingURL=GivePopup.js.map